import { render, staticRenderFns } from "./newCreateOrder.vue?vue&type=template&id=0e0a80ee&scoped=true&"
import script from "./newCreateOrder.vue?vue&type=script&lang=js&"
export * from "./newCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./newCreateOrder.vue?vue&type=style&index=0&id=0e0a80ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a80ee",
  null
  
)

export default component.exports